import { useQuery } from '@/hooks/useQuery'
import { queryKeys } from '@/api/queryKeys'
import { apiClient } from '../client'

export interface DashboardOverview {
  totalWorkOrders: number
  openWorkOrders: number
  waitingPartsWorkOrders: number
  waitingAcceptanceWorkOrders: number
  lowStockItems: number
  workOrderStatusCounts: Record<string, number>
}

export async function getDashboardOverview(): Promise<DashboardOverview> {
  return apiClient.get<DashboardOverview>('/api/dashboard/overview')
}

export function useDashboardOverview() {
  return useQuery({
    queryKey: queryKeys.dashboardOverview,
    queryFn: getDashboardOverview,
  })
}
